import type { ReactNode } from 'react';
import type { ItemCustomFieldValue } from '@/common/api/types/items';

export const HeaderWithIconFormatter = ({ icon, text }: { icon: ReactNode; text: string }) => {
  return (
    <span className="flex text-text-neutral-secondary">
      {icon} {text}
    </span>
  );
};

export const renderCustomFieldValue = (fieldValue: ItemCustomFieldValue | undefined): ReactNode => {
  if (!fieldValue) return null;

  if ('LINK' in fieldValue) {
    return (
      <a
        href={fieldValue.LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="text-text-link hover:text-text-info-bold underline"
      >
        {'description' in fieldValue ? fieldValue.description : fieldValue.LINK}
      </a>
    );
  }

  return JSON.stringify(fieldValue);
};
